module.exports = __webpack_public_path__ + "img/ideation-1_cn.b0de25c.jpg";